import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import classnames from "classnames";
import BackgroundVideo from "../components/Background-Video";
import { motion } from "framer-motion";
import Videos from "../video/101160_SCS_Interactive_Sc0_4K_10s_V2.mp4";

const Experience = () => {
	return (
		<>
			<style>
				{
					`
					
	                
	                .button-new {
	                    background: rgb(0 118 206);
	                    padding: 10px 30px;
	                    color: #fff;
	                    display: inline-block;
	                }
	                
	                .display-fullscreen-new {
	                    z-index: 999999;
	                    background: rgb(0 0 0 / 61%);
	                }
	                
	                .boxed {
	                    background: #fff;
	                    padding: 40px;
	                    max-width: 800px;
	                    top: 10px;
	                    position: absolute;
	                    left: 10px;
	                }
	                `
				}
			</style>

			<div className={classnames("w-screen h-[100vh] fixed top-0 left-0 z-index-[10] display-fullscreen-new")}>
				<div className={classnames("boxed")}>
					<h1
						className={classnames(
							"mb-5 text-[#0076CE] text-[30px] 2xl:text-[30px] font-proxima-nova text-dell-blue font-light"
						)}
					>

						We recommend you enable fullscreen mode on <br/>your browser to experience the interactive guide.


					</h1>
					<p
						className={classnames(
							"font-proxima-nova text-[#444444] text-sm 2xl:text-[20px] 2xl:leading-[24px] font-thin mt-10"
						)}
					>

						<Link to='/home' className={classnames(
							"font-proxima-nova text-[#444444] text-sm 2xl:text-[20px] 2xl:leading-[24px] font-thin button-new"
						)}>
							Continue to homepage
						</Link>
					</p>
				</div>
			</div>
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			transition={{ duration: 0.4 }}
			className="w-screen h-[calc(100vh-172px)] relative top-[172px] left-0"
		>
			<BackgroundVideo
				fullscreen
				video={Videos}
			/>

			<div className="w-screen h-[calc(100vh-172px)] relative">
				<div className="w-[500px] 2xl:w-[800px] py-7 px-9 2xl:py-14 2xl:px-[59px] rounded-3xl relative left-10 top-5 mr-auto">
					<div className={classnames("")}>
						<h1
							className={classnames(
								"mb-5 text-[#0076CE] text-[30px] 2xl:text-[50px] font-proxima-nova text-dell-blue font-light"
							)}
						>
							Solutions Co-Creation Services
						</h1>
						<p
							className={classnames(
								"font-proxima-nova text-[#444444] text-sm 2xl:text-[20px] 2xl:leading-[24px] font-thin"
							)}
						>
							Through a co-creation partnership with Dell, you will be able to:
						</p>
						<ul
							className={classnames(
								"w-[300px] 2xl:w-[550px] text-[#444444] font-proxima-nova pb-5 list-disc pl-5 mt-5"
							)}
						>
							<li className={classnames("font-proxima-nova text-[#444444] text-sm 2xl:text-[20px] 2xl:leading-[24px] mb-5")}>
								Access new revenue streams by driving specific enterprise
								customer outcomes
							</li>
							<li className={classnames("font-proxima-nova text-[#444444] text-sm 2xl:text-[20px] 2xl:leading-[24px] mb-5")}>
								Leverage an incentivized, experienced global Dell salesforce to
								increase revenue
							</li>
							<li className={classnames("font-proxima-nova text-[#444444] text-sm 2xl:text-[20px] 2xl:leading-[24px] mb-5")}>
								Utilize our strong portfolio of enterprise-ready solutions to
								extend your scope
							</li>
							<li className={classnames("font-proxima-nova text-[#444444] text-sm 2xl:text-[20px] 2xl:leading-[24px] mb-5")}>
								Use our proven repeatable process for an accelerated time to
								market
							</li>
						</ul>
						<p
							className={classnames(
								"font-proxima-nova text-[#444444] text-sm leading-sm 2xl:text-[20px] 2xl:leading-[26px] font-extralight"
							)}
						>
							Explore the SCS solution catalog though this interactive
							experience that illustrates how partnering with Dell to co-create
							solutions can help you monetize your 5G investment, grow your
							managed services business and give you access to edge and
							enterprise data center spend.
						</p>
					</div>
				</div>

				<div className="edge-dots absolute w-screen h-[calc(100vh-172px)] top-0 grid grid-cols-5 grid-rows-3">
					<div></div>
					<div></div>
					<div></div>

					<div></div>
					<div></div>

					<div></div>

					<div></div>
					<div></div>

					<div></div>
				</div>
			</div>
		</motion.div>
			</>
	);
};

export default Experience;
